import {
  DRAFT_STATUS,
  object,
  relation,
  subject,
} from "../../utils/helpers/triplets";
import { DRAFT_STATES } from "@consts";

export const handleDraftTripletsSelector = state => [
  state.publishCurrentTripletsToDraft,
  state.deleteCurrentDraft
];
export const deletePublishedDraftSelector = state =>
  state.deletePublishedDraft;
export const updateCurrentTripletsSelector = state =>
  state.updateCurrentTriplets;
export const isRefreshingTripletsSelector = state =>
  state.tripletsStatus === DRAFT_STATUS.LOADING
  || state.tripletsStatus === DRAFT_STATUS.PUBLISHING;
export const isSavingTripletsSelector = state =>
  state.tripletsStatus === DRAFT_STATUS.SAVING;
export const isPublishingTripletsSelector = state =>
  state.tripletsStatus === DRAFT_STATUS.PUBLISHING;
export const isTripletsIdleSelector = state =>
  state.tripletsStatus === DRAFT_STATUS.IDLE;
export const draftSelector = state => state.draft;
export const isEditModeSelector = state =>
  state.draft?.status === DRAFT_STATES.EDIT;
export const failedToCreateDraftSelector = state => state.failedToCreateDraft;
export const setFailedToCreateDraftSelector = state =>
  state.setFailedToCreateDraftSelector;
export const failedToPublishDraftSelector = state =>
  state.failedToPublishDraft;
export const setFailedToPublishDraftSelector = state =>
  state.setFailedToPublishDraftSelector;
export const infoPopoversSelector = state => state.infoPopovers;
export const setInfoPopoversSelector = state =>
  state.setInfoPopovers;
export const couldNotLoadTripletsSelector = state =>
  state.couldNotLoadTriplets;
export const setCouldNotLoadTripletsSelector = state =>
  state.setCouldNotLoadTriplets;
export const currentTripletsSelector = state => state.displayedTriplets;
export const originalTripletsSelector = state => state.originalTriplets;
export const isTriggerInGraphSelector = state => state.isTriggerInGraph;
export const createNewDataSourceSelector = state => state.createNewDataSource;
export const updateDataSourceSelector = state => state.updateExistingDataSource;
export const deleteDataSourceSelector = state => state.deleteDataSourceFile;
